module.exports = __webpack_public_path__ + "img/hr-V-R-246-unload-standup-base.ff981bf3.png";